import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import useManageStorage from '../../../hooks/useManageStorage/useManageStorage';
import { ContentLayout } from '../../../global-styles/layout';
import Header from '../../../components/header/Header';
import ConfirmationSuccess from './success/comfirmation-success';
import ConfirmationNotice from './notice/confirmation-notice';
import ConfirmationError from './error/confirmation-error';
import { ConfirmationStyle } from './confirmation-style';
import CallMeBack from './call-me-back/CallMeBack';

const Confirmation = () => {
  const { state } = useParams<{ state: string; intervention: string; identifier: string }>();
  const [renderConfirmation] = useState<string>(typeof state === 'string' ? state : '');
  const { readFromStorage } = useManageStorage();

  useEffect(() => {
    readFromStorage();
  }, [readFromStorage]);

  const renderSection = () => {
    switch (renderConfirmation) {
      case 'success':
        return <ConfirmationSuccess />;
      case 'error':
        return <ConfirmationError />;
      case 'notice':
        return <ConfirmationNotice />;
      case 'call-me-back':
        return <CallMeBack />;
      default:
        return <ConfirmationNotice />;
    }
  };

  return (
    <>
      <ConfirmationStyle color="red">
        <Header showNotifications={false} />
        <ContentLayout>{renderSection()}</ContentLayout>
      </ConfirmationStyle>
    </>
  );
};

export default Confirmation;
